import * as THREE from "three";
import { HighLevelJoint, MeshConfig } from "types/stl";

export const P0: HighLevelJoint = {
  vertices: [
    {
      ids: [91, 94, 107, 110, 113, 207, 218, 304],
      weight: 1.0,
    },
  ],
  centerId: 94,
  name: "P0",
  min: -10,
  max: 10,
  value: 0,
  center: new THREE.Vector3(0, 0, 0),
  cval: 0,
  bval: 1,
};

export const P1: HighLevelJoint = {
  vertices: [
    {
      ids: [92, 93, 114, 115, 149, 246, 251, 303],
      weight: 1.0,
    },
  ],
  centerId: 93,
  name: "P1",
  min: -10,
  max: 10,
  value: 0,
  center: new THREE.Vector3(0, 0, 0),
  cval: 0,
  bval: 1,
};

export const P2: HighLevelJoint = {
  vertices: [
    {
      ids: [6, 7, 148, 150, 224, 247, 248, 264],
      weight: 1.0,
    },
  ],
  centerId: 7,
  name: "P2",
  min: -10,
  max: 10,
  value: 0,
  center: new THREE.Vector3(0, 0, 0),
  cval: 0,
  bval: 1,
};

export const P3: HighLevelJoint = {
  vertices: [
    {
      ids: [4, 5, 151, 152, 174, 214, 252, 265],
      weight: 1.0,
    },
  ],
  centerId: 4,
  name: "P3",
  min: -10,
  max: 10,
  value: 0,
  center: new THREE.Vector3(0, 0, 0),
  cval: 0,
  bval: 1,
};

export const P4: HighLevelJoint = {
  vertices: [
    {
      ids: [45, 46, 133, 134, 215, 223, 250, 288],
      weight: 1.0,
    },
  ],
  centerId: 46,
  name: "P4",
  min: -10,
  max: 10,
  value: 0,
  center: new THREE.Vector3(0, 0, 0),
  cval: 0,
  bval: 1,
};

export const P5: HighLevelJoint = {
  vertices: [
    {
      ids: [43, 44, 105, 131, 132, 222, 245, 289],
      weight: 1.0,
    },
  ],
  centerId: 43,
  name: "P5",
  min: -10,
  max: 10,
  value: 0,
  center: new THREE.Vector3(0, 0, 0),
  cval: 0,
  bval: 1,
};

export const P6: HighLevelJoint = {
  vertices: [
    {
      ids: [20, 21, 60, 61, 106, 173, 253, 274],
      weight: 1.0,
    },
  ],
  centerId: 21,
  name: "P6",
  min: -10,
  max: 10,
  value: 0,
  center: new THREE.Vector3(0, 0, 0),
  cval: 0,
  bval: 1,
};

export const P7: HighLevelJoint = {
  vertices: [
    {
      ids: [18, 19, 59, 62, 172, 202, 255, 275],
      weight: 1.0,
    },
  ],
  centerId: 18,
  name: "P7",
  min: -10,
  max: 10,
  value: 0,
  center: new THREE.Vector3(0, 0, 0),
  cval: 0,
  bval: 1,
};

export const P8: HighLevelJoint = {
  vertices: [
    {
      ids: [129, 130, 143, 197, 205, 213, 235, 326],
      weight: 1.0,
    },
    {
      ids: [327],
      weight: 0,
    }
  ],
  centerId: 213,
  name: "P8",
  min: -10,
  max: 10,
  value: 0,
  center: new THREE.Vector3(0, 0, 0),
  cval: 0,
  bval: 1,
};

export const P9: HighLevelJoint = {
  vertices: [
    {
      ids: [27, 28, 56, 57, 128, 169, 236, 277],
      weight: 1.0,
    },
    {
      ids: [295],
      weight: 0,
    }
  ],
  centerId: 28,
  name: "P9",
  min: -10,
  max: 10,
  value: 0,
  center: new THREE.Vector3(0, 0, 0),
  cval: 0,
  bval: 1,
};

export const P10: HighLevelJoint = {
  vertices: [
    {
      ids: [25, 26, 55, 58, 138, 168, 210, 278],
      weight: 1.0,
    },
    {
      ids: [294],
      weight: 0,
    }
  ],
  centerId: 25,
  name: "P10",
  min: -10,
  max: 10,
  value: 0,
  center: new THREE.Vector3(0, 0, 0),
  cval: 0,
  bval: 1,
};

export const P11: HighLevelJoint = {
  vertices: [
    {
      ids: [135, 136, 137, 182, 190, 196, 211, 322],
      weight: 1.0,
    },
    {
      ids: [323],
      weight: 0,
    }
  ],
  centerId: 196,
  name: "P11",
  min: -10,
  max: 10,
  value: 0,
  center: new THREE.Vector3(0, 0, 0),
  cval: 0,
  bval: 1,
};

export const P12: HighLevelJoint = {
  vertices: [
    {
      ids: [103, 104, 111, 144, 145, 175, 258, 314],
      weight: 1.0,
    },
    {
      ids: [98],
      weight: 0.35,
    },
  ],
  centerId: 104,
  name: "P12",
  min: -10,
  max: 10,
  value: 0,
  center: new THREE.Vector3(0, 0, 0),
  cval: 0,
  bval: 1,
};

export const P13: HighLevelJoint = {
  vertices: [
    {
      ids: [2, 3, 48, 49, 112, 165, 257, 262],
      weight: 1.0,
    },
    {
      ids: [95],
      weight: 0.35,
    },
  ],
  centerId: 3,
  name: "P13",
  min: -10,
  max: 10,
  value: 0,
  center: new THREE.Vector3(0, 0, 0),
  cval: 0,
  bval: 1,
};

export const P14: HighLevelJoint = {
  vertices: [
    {
      ids: [0, 1, 47, 50, 164, 179, 191, 263],
      weight: 1.0,
    },
    {
      ids: [116],
      weight: 0.35,
    },
  ],
  centerId: 0,
  name: "P14",
  min: -10,
  max: 10,
  value: 0,
  center: new THREE.Vector3(0, 0, 0),
  cval: 0,
  bval: 1,
};

export const P15: HighLevelJoint = {
  vertices: [
    {
      ids: [36, 37, 68, 69, 154, 178, 192, 284],
      weight: 1.0,
    },
    {
      ids: [117],
      weight: 0.35,
    },
  ],
  centerId: 36,
  name: "P15",
  min: -10,
  max: 10,
  value: 0,
  center: new THREE.Vector3(0, 0, 0),
  cval: 0,
  bval: 1,
};

export const P16: HighLevelJoint = {
  vertices: [
    {
      ids: [67, 70, 119, 120, 153, 226, 261, 318],
      weight: 1.0,
    },
    {
      ids: [118],
      weight: 0.35,
    },
  ],
  centerId: 119,
  name: "P16",
  min: -10,
  max: 10,
  value: 0,
  center: new THREE.Vector3(0, 0, 0),
  cval: 0,
  bval: 1,
};

export const P17: HighLevelJoint = {
  vertices: [
    {
      ids: [71, 72, 147, 225, 227, 229, 260, 329],
      weight: 1.0,
    },
    {
      ids: [228],
      weight: 0.35,
    },
  ],
  centerId: 225,
  name: "P17",
  min: -10,
  max: 10,
  value: 0,
  center: new THREE.Vector3(0, 0, 0),
  cval: 0,
  bval: 1,
};

export const P18: HighLevelJoint = {
  vertices: [
    {
      ids: [64, 65, 146, 230, 231, 254, 259, 330],
      weight: 1.0,
    },
    {
      ids: [102],
      weight: 0.35,
    },
  ],
  centerId: 230,
  name: "P18",
  min: -10,
  max: 10,
  value: 0,
  center: new THREE.Vector3(0, 0, 0),
  cval: 0,
  bval: 1,
};

export const P19: HighLevelJoint = {
  vertices: [
    {
      ids: [63, 66, 163, 232, 233, 238, 240, 331],
      weight: 1.0,
    },
    {
      ids: [101],
      weight: 0.35,
    },
  ],
  centerId: 233,
  name: "P19",
  min: -10,
  max: 10,
  value: 0,
  center: new THREE.Vector3(0, 0, 0),
  cval: 0,
  bval: 1,
};

export const P20: HighLevelJoint = {
  vertices: [
    {
      ids: [74, 75, 100, 161, 162, 237, 239, 310],
      weight: 1.0,
    },
    {
      ids: [186],
      weight: 0.35,
    },
  ],
  centerId: 74,
  name: "P20",
  min: -10,
  max: 10,
  value: 0,
  center: new THREE.Vector3(0, 0, 0),
  cval: 0,
  bval: 1,
};

export const P21: HighLevelJoint = {
  vertices: [
    {
      ids: [73, 76, 99, 176, 177, 185, 256, 311],
      weight: 1.0,
    },
    {
      ids: [320],
      weight: 0,
    }
  ],
  centerId: 73,
  name: "P21",
  min: -10,
  max: 10,
  value: 0,
  center: new THREE.Vector3(0, 0, 0),
  cval: 0,
  bval: 1,
};

export const P22: HighLevelJoint = {
  vertices: [
    {
      ids: [30, 122, 123, 180, 181, 195, 242, 282],
      weight: 1.0,
    },
    {
      ids: [279],
      weight: 0,
    }
  ],
  centerId: 195,
  name: "P22",
  min: -10,
  max: 10,
  value: 0,
  center: new THREE.Vector3(0, 0, 0),
  cval: 0,
  bval: 1,
};

export const P23: HighLevelJoint = {
  vertices: [
    {
      ids: [31, 35, 52, 53, 121, 167, 220, 281],
      weight: 1.0,
    },
    {
      ids: [280],
      weight: 0,
    }
  ],
  centerId: 35,
  name: "P23",
  min: -10,
  max: 10,
  value: 0,
  center: new THREE.Vector3(0, 0, 0),
  cval: 0,
  bval: 1,
};

export const P24: HighLevelJoint = {
  vertices: [
    {
      ids: [33, 34, 51, 54, 142, 166, 221, 283],
      weight: 1.0,
    },
    {
      ids: [325],
      weight: 0,
    }
  ],
  centerId: 33,
  name: "P24",
  min: -10,
  max: 10,
  value: 0,
  center: new THREE.Vector3(0, 0, 0),
  cval: 0,
  bval: 1,
};

export const P25: HighLevelJoint = {
  vertices: [
    {
      ids: [15, 139, 140, 141, 200, 212, 241, 273],
      weight: 1.0,
    },
  ],
  centerId: 212,
  name: "P25",
  min: -10,
  max: 10,
  value: 0,
  center: new THREE.Vector3(0, 0, 0),
  cval: 0,
  bval: 1,
};

export const P26: HighLevelJoint = {
  vertices: [
    {
      ids: [16, 24, 198, 199, 219, 243, 244, 272],
      weight: 1.0,
    },
  ],
  centerId: 24,
  name: "P26",
  min: -10,
  max: 10,
  value: 0,
  center: new THREE.Vector3(0, 0, 0),
  cval: 0,
  bval: 1,
};

export const P27: HighLevelJoint = {
  vertices: [
    {
      ids: [22, 23, 124, 127, 159, 234, 249, 276],
      weight: 1.0,
    },
  ],
  centerId: 22,
  name: "P27",
  min: -10,
  max: 10,
  value: 0,
  center: new THREE.Vector3(0, 0, 0),
  cval: 0,
  bval: 1,
};

export const P28: HighLevelJoint = {
  vertices: [
    {
      ids: [39, 40, 125, 126, 156, 157, 160, 285],
      weight: 1.0,
    },
  ],
  centerId: 39,
  name: "P28",
  min: -10,
  max: 10,
  value: 0,
  center: new THREE.Vector3(0, 0, 0),
  cval: 0,
  bval: 1,
};

export const P29: HighLevelJoint = {
  vertices: [
    {
      ids: [13, 38, 155, 158, 183, 184, 193, 269],
      weight: 1.0,
    },
  ],
  centerId: 13,
  name: "P29",
  min: -10,
  max: 10,
  value: 0,
  center: new THREE.Vector3(0, 0, 0),
  cval: 0,
  bval: 1,
};

export const P30: HighLevelJoint = {
  vertices: [
    {
      ids: [10, 11, 170, 171, 194, 208, 209, 266],
      weight: 1.0,
    },
  ],
  centerId: 10,
  name: "P30",
  min: -10,
  max: 10,
  value: 0,
  center: new THREE.Vector3(0, 0, 0),
  cval: 0,
  bval: 1,
};

export const P31: HighLevelJoint = {
  vertices: [
    {
      ids: [8, 9, 108, 109, 201, 216, 217, 267],
      weight: 1.0,
    },
  ],
  centerId: 8,
  name: "P31",
  min: -10,
  max: 10,
  value: 0,
  center: new THREE.Vector3(0, 0, 0),
  cval: 0,
  bval: 1,
};

export const heelDepthJoint: HighLevelJoint = {
  vertices: [
    {
      ids: [0, 2, 3, 36, 112, 119, 225, 227,
        229, 230, 231, 232, 233, 240, 254],
      weight: 1.0
    },
    {
      ids: [
        1,
        37,
        120,
        191,
        192
      ],
      weight: 0.99
    },
    {
      ids: [
        226
      ],
      weight: 0.97
    },
    {
      ids: [
        178,
        179,
        238,
        257,
        259,
        260,
        261
      ],
      weight: 0.6
    },
    {
      ids: [
        74,
        103,
        104
      ],
      weight: 0.67
    },
    {
      ids: [
        100
      ],
      weight: 0.66
    },
    {
      ids: [
        75
      ],
      weight: 0.65
    },
    {
      ids: [
        111
      ],
      weight: 0.64
    },
    {
      ids: [
        67
      ],
      weight: 0.59
    },
    {
      ids: [
        63
      ],
      weight: 0.55
    },
    {
      ids: [
        64
      ],
      weight: 0.53
    },
    {
      ids: [
        48,
        71
      ],
      weight: 0.52
    },
    {
      ids: [
        47,
        68
      ],
      weight: 0.51
    },
    {
      ids: [
        117
      ],
      weight: 0.41
    },
    {
      ids: [
        95,
        101
      ],
      weight: 0.4
    },
    {
      ids: [
        102,
        116
      ],
      weight: 0.39
    },
    {
      ids: [
        228
      ],
      weight: 0.37
    },
    {
      ids: [
        237
      ],
      weight: 0.35
    },
    {
      ids: [
        118
      ],
      weight: 0.32
    },
    {
      ids: [
        258
      ],
      weight: 0.21
    },
    {
      ids: [
        73,
        76,
        99,
        190,
        196,
        211
      ],
      weight: 0.15
    },
    {
      ids: [
        256
      ],
      weight: 0.13
    },
    {
      ids: [
        98,
        186
      ],
      weight: 0.04
    },
    {
      ids: [
        137
      ],
      weight: 0.03
    },
    {
      ids: [
        70,
        189
      ],
      weight: 0.01
    },
    {
      ids: [
        25,
        26,
        81,
        96,
        144,
        187,
        242
      ],
      weight: 0.0
    }
  ],
  centerId: 96,
  center: new THREE.Vector3(0, 0, 0),
  name: "Heel Depth",
  min: 1,
  max: 40,
  value: 5,
  cval: 1.522,
  bval: 0.8129,
};

export const heelHeightJoint: HighLevelJoint = {
  vertices: [
    {
      ids: [0, 1, 2, 3, 36, 37, 95, 96, 101, 102, 112, 116,
        117, 118, 119, 120, 178, 179, 191, 192, 225, 226, 227, 228,
        229, 230, 231, 232, 233, 238, 240, 254, 257, 259, 260, 261],
      weight: 1.0
    },
    {
      ids: [
        237,
        258
      ],
      weight: 0.84
    },
    {
      ids: [
        74,
        75,
        97,
        98,
        100,
        103,
        104,
        111,
        186
      ],
      weight: 0.83
    },
    {
      ids: [
        67
      ],
      weight: 0.78
    },
    {
      ids: [
        63
      ],
      weight: 0.74
    },
    {
      ids: [
        64
      ],
      weight: 0.71
    },
    {
      ids: [
        48
      ],
      weight: 0.7
    },
    {
      ids: [
        71,
        256
      ],
      weight: 0.69
    },
    {
      ids: [
        47,
        68
      ],
      weight: 0.68
    },
    {
      ids: [
        73,
        76,
        99,
        137,
        187,
        188,
        189,
        190,
        196,
        211
      ],
      weight: 0.67
    },
    {
      ids: [
        239
      ],
      weight: 0.63
    },
    {
      ids: [
        185
      ],
      weight: 0.54
    },
    {
      ids: [
        122,
        138
      ],
      weight: 0.52
    },
    {
      ids: [
        25,
        26,
        29,
        30,
        81,
        82,
        195,
        210,
        242
      ],
      weight: 0.57
    },
    {
      ids: [
        144
      ],
      weight: 0.49
    },
    {
      ids: [
        123
      ],
      weight: 0.42
    },
    {
      ids: [
        128, 121
      ],
      weight: 0.3
    },
    {
      ids: [
        27,
        28,
        31,
        32,
        35,
        83,
        84,
        220,
        236
      ],
      weight: 0.33
    },
    {
      ids: [
        136
      ],
      weight: 0.32
    },
    {
      ids: [
        52
      ],
      weight: 0.28
    },
    {
      ids: [
        55
      ],
      weight: 0.22
    },
    {
      ids: [
        129,
        142
      ],
      weight: 0.21
    },
    {
      ids: [
        33,
        34,
        56,
        203,
        204,
        205,
        206,
        213,
        221,
        235
      ],
      weight: 0.17
    },
    {
      ids: [
        51
      ],
      weight: 0.15
    },
    {
      ids: [
        130
      ],
      weight: 0.14
    },
    {
      ids: [
        140,
        141,
        255
      ],
      weight: 0.05
    },
    {
      ids: [
        59,
        70,
        145
      ],
      weight: 0.01
    },
    {
      ids: [
        16,
        17,
        49,
        58,
        62,
        135,
        143
      ],
      weight: 0.0
    }
  ],
  centerId: 96,
  center: new THREE.Vector3(0, 0, 0),
  name: "Heel Height",
  min: 0,
  max: 40,
  value: 4,
  cval: 0.6662,
  bval: 0.9763,
};

export const heelLateralJoint: HighLevelJoint = {
  vertices: [
    {
      ids: [
        2,
        3
      ],
      weight: 1.0
    },
    {
      ids: [
        112
      ],
      weight: 0.99
    },
    {
      ids: [
        0
      ],
      weight: 0.82
    },
    {
      ids: [
        1
      ],
      weight: 0.81
    },
    {
      ids: [
        191
      ],
      weight: 0.8
    },
    {
      ids: [
        103,
        104
      ],
      weight: 0.74
    },
    {
      ids: [
        111
      ],
      weight: 0.71
    },
    {
      ids: [
        95
      ],
      weight: 0.57
    },
    {
      ids: [
        36,
        37
      ],
      weight: 0.56
    },
    {
      ids: [
        192
      ],
      weight: 0.55
    },
    {
      ids: [
        116
      ],
      weight: 0.47
    },
    {
      ids: [
        98
      ],
      weight: 0.41
    },
    {
      ids: [
        190,
        196,
        211
      ],
      weight: 0.35
    },
    {
      ids: [
        117,
        178,
        179,
        257,
        258
      ],
      weight: 0.25
    },
    {
      ids: [
        189
      ],
      weight: 0.21
    },
    {
      ids: [
        25,
        26,
        81,
        210
      ],
      weight: 0.14
    },
    {
      ids: [
        137
      ],
      weight: 0.1
    },
    {
      ids: [
        120
      ],
      weight: 0.01
    },
    {
      ids: [
        27,
        28,
        47,
        96,
        118,
        119,
        136,
        138,
        144,
        188,
        226,
        236
      ],
      weight: 0.0
    }
  ],
  centerId: 2,
  center: new THREE.Vector3(0, 0, 0),
  name: "Heel Lateral Wedge",
  min: 0,
  max: 10,
  value: 0,
  cval: 0,
  bval: 1,
};

export const heelMedialJoint: HighLevelJoint = {
  vertices: [
    {
      ids: [
        232,
        233
      ],
      weight: 1.0
    },
    {
      ids: [
        240
      ],
      weight: 0.99
    },
    {
      ids: [
        230,
        231,
        254
      ],
      weight: 0.83
    },
    {
      ids: [
        74
      ],
      weight: 0.74
    },
    {
      ids: [
        100
      ],
      weight: 0.72
    },
    {
      ids: [
        75
      ],
      weight: 0.71
    },
    {
      ids: [
        225,
        229
      ],
      weight: 0.55
    },
    {
      ids: [
        101
      ],
      weight: 0.54
    },
    {
      ids: [
        102
      ],
      weight: 0.52
    },
    {
      ids: [
        227
      ],
      weight: 0.5
    },
    {
      ids: [
        186
      ],
      weight: 0.38
    },
    {
      ids: [
        73,
        76,
        99
      ],
      weight: 0.35
    },
    {
      ids: [
        228,
        237,
        238,
        256,
        259
      ],
      weight: 0.25
    },
    {
      ids: [
        187
      ],
      weight: 0.2
    },
    {
      ids: [
        260
      ],
      weight: 0.17
    },
    {
      ids: [
        30,
        195,
        242
      ],
      weight: 0.14
    },
    {
      ids: [
        29,
        122
      ],
      weight: 0.13
    },
    {
      ids: [
        35,
        64,
        82,
        121,
        188,
        220
      ],
      weight: 0.0
    }
  ],
  centerId: 232,
  center: new THREE.Vector3(0, 0, 0),
  name: "Heel Medial Wedge",
  min: 0,
  max: 10,
  value: 0,
  cval: 0,
  bval: 1,
};

export const archLateralJoint: HighLevelJoint = {
  vertices: [
    {
      ids: [
        27,
        28,
        236
      ],
      weight: 0.96
    },
    {
      ids: [
        25,
        26,
        210
      ],
      weight: 0.93
    },
    {
      ids: [
        196,
        211
      ],
      weight: 0.6
    },
    {
      ids: [
        190
      ],
      weight: 0.59
    },
    {
      ids: [
        205,
        213,
        235
      ],
      weight: 0.5
    },
    {
      ids: [
        129
      ],
      weight: 0.36
    },
    {
      ids: [
        56,
        128,
        138
      ],
      weight: 0.3
    },
    {
      ids: [
        55
      ],
      weight: 0.29
    },
    {
      ids: [
        137
      ],
      weight: 0.25
    },
    {
      ids: [
        189
      ],
      weight: 0.22
    },
    {
      ids: [
        81,
        136
      ],
      weight: 0.21
    },
    {
      ids: [
        84
      ],
      weight: 0.2
    },
    {
      ids: [
        130
      ],
      weight: 0.17
    },
    {
      ids: [
        206
      ],
      weight: 0.16
    },
    {
      ids: [
        103,
        104,
        111,
        258
      ],
      weight: 0.07
    },
    {
      ids: [
        144
      ],
      weight: 0.06
    },
    {
      ids: [
        18,
        19,
        85,
        202
      ],
      weight: 0.04
    },
    {
      ids: [
        98,
        255
      ],
      weight: 0.03
    },
    {
      ids: [
        59,
        86,
        203
      ],
      weight: 0.01
    },
    {
      ids: [
        2,
        58,
        62,
        95,
        112,
        135,
        143,
        145,
        188,
        257
      ],
      weight: 0.0
    }
  ],
  centerId: 26,
  center: new THREE.Vector3(0, 0, 0),
  name: "Arch Lateral Height",
  min: 1,
  max: 40,
  value: 0,
  cval: 0.1166,
  bval: 0.8788,
};

export const archCenterJoint: HighLevelJoint = {
  vertices: [
    {
      ids: [82, 83, 203],
      weight: 1.0,
    },
    {
      ids: [32, 81, 84, 204],
      weight: 0.85,
    },
    {
      ids: [14, 29, 86, 188, 189, 206],
      weight: 0.7,
    },
    {
      ids: [85, 187],
      weight: 0.5,
    },
  ],
  centerId: 82,
  center: new THREE.Vector3(0, 0, 0),
  name: "Arch Center Height",
  min: 1,
  max: 40,
  value: 0,
  cval: 1.1951,
  bval: 0.841,
};

export const archMedialJoint: HighLevelJoint = {
  vertices: [
    {
      ids: [
        35,
        220
      ],
      weight: 0.96
    },
    {
      ids: [
        31
      ],
      weight: 0.95
    },
    {
      ids: [
        195,
        242
      ],
      weight: 0.93
    },
    {
      ids: [
        30
      ],
      weight: 0.92
    },
    {
      ids: [
        73,
        99,
        121,
        122
      ],
      weight: 0.6
    },
    {
      ids: [
        33,
        34,
        76
      ],
      weight: 0.53
    },
    {
      ids: [
        221
      ],
      weight: 0.51
    },
    {
      ids: [
        52
      ],
      weight: 0.49
    },
    {
      ids: [
        142
      ],
      weight: 0.48
    },
    {
      ids: [
        256
      ],
      weight: 0.44
    },
    {
      ids: [
        123
      ],
      weight: 0.36
    },
    {
      ids: [
        185
      ],
      weight: 0.34
    },
    {
      ids: [
        51
      ],
      weight: 0.27
    },
    {
      ids: [
        29
      ],
      weight: 0.25
    },
    {
      ids: [
        32
      ],
      weight: 0.23
    },
    {
      ids: [
        187
      ],
      weight: 0.21
    },
    {
      ids: [
        204
      ],
      weight: 0.16
    },
    {
      ids: [
        74,
        75,
        100,
        237
      ],
      weight: 0.06
    },
    {
      ids: [
        14,
        15,
        140,
        141,
        212,
        241
      ],
      weight: 0.04
    },
    {
      ids: [
        186
      ],
      weight: 0.03
    },
    {
      ids: [
        82,
        83
      ],
      weight: 0.01
    },
    {
      ids: [
        16,
        86,
        101,
        188,
        232,
        238,
        240
      ],
      weight: 0.0
    }
  ],
  centerId: 30,
  center: new THREE.Vector3(0, 0, 0),
  name: "Arch Medial Height",
  min: 1,
  max: 40,
  value: 0,
  cval: -0.2439,
  bval: 0.9072,
};

export const archEditorJoint: HighLevelJoint = {
  vertices: [
    {
      ids: [
        24, 16, 17, 87, 88, 20, 21, 106, 253, 60, 61, 173, 274, 299, 300, 271, 272, 198, 199, 244, 243, 219,
        2, 3, 14, 15, 18, 19, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 48, 49, 51, 52, 53, 54, 55, 56, 57,
        58, 59, 62, 63, 66, 73, 74, 75, 76, 81, 82, 83, 84, 85, 86, 95, 96, 97, 98, 99, 100, 101, 103, 104,
        111, 112, 121, 122, 123, 128, 129, 130, 135, 136, 137, 138, 139, 140, 141, 142, 143, 144, 145, 161, 162,
        163, 165, 166, 167, 168, 169, 172, 175, 176, 177, 180, 181, 182, 185, 186, 187, 188, 189, 190, 195,
        196, 197, 200, 202, 203, 204, 205, 206, 210, 211, 212, 213, 220, 221, 232, 233, 235, 236, 237, 238,
        239, 240, 241, 242, 255, 256, 257, 258, 262, 270, 273, 275, 277, 278, 279, 280, 281, 282, 283, 294,
        295, 296, 297, 298, 301, 306, 307, 308, 309, 310, 311, 312, 314, 319, 320, 321, 322, 323, 324, 325,
        326, 327, 331
      ],
      weight: 1
    },
    {
      ids: [
        4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 22, 23, 38, 39, 40,
        41, 42, 43, 44, 45, 46, 77, 78, 79, 80, 89, 90, 91, 92, 93, 94,
        105, 107, 108, 109, 110, 113, 114, 115, 124, 125, 126, 127, 131, 132, 133, 134, 148, 149, 150,
        151, 152, 155, 156, 157, 158, 159, 160, 170, 171, 174, 183, 184, 193, 194, 201, 207,
        208, 209, 214, 215, 216, 217, 218, 222, 223, 224, 234, 245, 246, 247, 248, 249, 250,
        251, 252, 264, 265, 266, 267, 268, 269, 276, 285, 286, 287, 288, 289, 290, 291,
        292, 293, 302, 303, 304, 305
      ],
      weight: -1
    }
  ],
  centerId: 18,
  center: new THREE.Vector3(0, 0, 0),
  name: "Arch Sagital Position",
  min: 50,
  max: 70,
  value: 0,
  cval: 0,
  bval: 1,
}

export const thicknessJoint: HighLevelJoint = {
  vertices: [
    {
      ids: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12,
        13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25,
        26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38,
        39, 40, 41, 42, 43, 44, 45, 46, 73, 74, 75, 76, 77,
        78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90,
        91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103,
        104, 105, 111, 112, 116, 117, 118, 119, 120, 126, 127, 128,
        129, 141, 142, 159, 160, 178, 179, 184, 186, 187, 188, 189,
        190, 191, 192, 193, 194, 195, 196, 201, 202, 203, 204, 205,
        206, 207, 208, 210, 211, 212, 213, 214, 215, 216, 218, 219,
        220, 221, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232,
        233, 235, 236, 237, 238, 240, 241, 242, 243, 246, 248, 251,
        252, 254, 256, 257, 258, 259, 260, 261
      ],
      weight: 1.0
    },
    {
      ids: [
        122
      ],
      weight: 0.99
    },
    {
      ids: [
        137,
        138,
        222
      ],
      weight: 0.98
    },
    {
      ids: [
        121,
        255
      ],
      weight: 0.97
    },
    {
      ids: [
        106
      ],
      weight: 0.96
    },
    {
      ids: [
        67
      ],
      weight: 0.78
    },
    {
      ids: [
        185
      ],
      weight: 0.77
    },
    {
      ids: [
        123
      ],
      weight: 0.75
    },
    {
      ids: [
        63
      ],
      weight: 0.74
    },
    {
      ids: [
        130,
        239
      ],
      weight: 0.73
    },
    {
      ids: [
        64,
        253
      ],
      weight: 0.71
    },
    {
      ids: [
        48,
        151
      ],
      weight: 0.7
    },
    {
      ids: [
        59,
        71,
        133
      ],
      weight: 0.69
    },
    {
      ids: [
        47,
        68,
        247
      ],
      weight: 0.68
    },
    {
      ids: [
        52,
        125,
        183,
        209
      ],
      weight: 0.67
    },
    {
      ids: [
        113,
        115,
        132,
        217
      ],
      weight: 0.66
    },
    {
      ids: [
        144
      ],
      weight: 0.59
    },
    {
      ids: [
        51
      ],
      weight: 0.53
    },
    {
      ids: [
        56
      ],
      weight: 0.52
    },
    {
      ids: [
        136
      ],
      weight: 0.49
    },
    {
      ids: [
        124,
        244
      ],
      weight: 0.47
    },
    {
      ids: [
        55
      ],
      weight: 0.46
    },
    {
      ids: [
        60
      ],
      weight: 0.45
    },
    {
      ids: [
        140
      ],
      weight: 0.35
    },
    {
      ids: [
        134
      ],
      weight: 0.33
    },
    {
      ids: [
        131
      ],
      weight: 0.32
    },
    {
      ids: [
        152
      ],
      weight: 0.3
    },
    {
      ids: [
        107,
        108,
        114,
        148,
        155,
        156
      ],
      weight: 0.28
    },
    {
      ids: [
        61
      ],
      weight: 0.16
    },
    {
      ids: [
        62
      ],
      weight: 0.13
    },
    {
      ids: [
        70,
        145
      ],
      weight: 0.01
    },
    {
      ids: [
        58,
        109,
        143,
        149,
        150,
        170,
        172,
        174
      ],
      weight: 0.0
    },
  ],
  centerId: 87,
  center: new THREE.Vector3(20, 20, 20),
  name: "Thickness",
  min: 2,
  max: 10,
  value: 0,
  cval: 0, //0.2757,
  bval: 1,
};

export const forefootLateralJoint: HighLevelJoint = {
  vertices: [
    {
      ids: [18, 19, 20, 21, 43, 44, 45, 46],
      weight: 1.0
    },
    {
      ids: [
        202
      ],
      weight: 0.79
    },
    {
      ids: [
        105,
        106,
        215
      ],
      weight: 0.78
    },
    {
      ids: [
        129
      ],
      weight: 0.71
    },
    {
      ids: [
        4,
        5,
        213,
        214,
        235
      ],
      weight: 0.7
    },
    {
      ids: [
        205
      ],
      weight: 0.6
    },
    {
      ids: [
        255
      ],
      weight: 0.59
    },
    {
      ids: [
        222,
        223,
        252
      ],
      weight: 0.57
    },
    {
      ids: [
        130
      ],
      weight: 0.56
    },
    {
      ids: [
        6,
        7,
        224
      ],
      weight: 0.55
    },
    {
      ids: [
        77,
        80,
        85,
        88,
        89,
        248
      ],
      weight: 0.5
    },
    {
      ids: [
        92,
        93,
        246,
        251
      ],
      weight: 0.31
    },
    {
      ids: [
        128
      ],
      weight: 0.2
    },
    {
      ids: [
        56
      ],
      weight: 0.18
    },
    {
      ids: [
        206,
        236
      ],
      weight: 0.16
    },
    {
      ids: [
        28
      ],
      weight: 0.15
    },
    {
      ids: [
        27
      ],
      weight: 0.11
    },
    {
      ids: [
        86,
        87
      ],
      weight: 0.02
    },
    {
      ids: [
        78,
        79
      ],
      weight: 0.01
    },
    {
      ids: [
        84,
        90,
        91,
        94,
        143,
        203,
        218
      ],
      weight: 0.0
    }
  ],
  centerId: 20,
  center: new THREE.Vector3(0, 0, 0),
  name: "Forefoot Lateral Wedge",
  min: 0,
  max: 10,
  value: 0,
  cval: 0,
  bval: 1,
};

export const forefootMedialJoint: HighLevelJoint = {
  vertices: [
    {
      ids: [
        15,
        16,
        22,
        23,
        24,
        39,
        40,
        212
      ],
      weight: 1.0
    },
    {
      ids: [
        241
      ],
      weight: 0.79
    },
    {
      ids: [
        159,
        160
      ],
      weight: 0.78
    },
    {
      ids: [
        13,
        38,
        193
      ],
      weight: 0.7
    },
    {
      ids: [
        141
      ],
      weight: 0.59
    },
    {
      ids: [
        126,
        127,
        184
      ],
      weight: 0.57
    },
    {
      ids: [
        10,
        11,
        194
      ],
      weight: 0.55
    },
    {
      ids: [
        14,
        17,
        41,
        42,
        208
      ],
      weight: 0.5
    },
    {
      ids: [
        142
      ],
      weight: 0.4
    },
    {
      ids: [
        140
      ],
      weight: 0.39
    },
    {
      ids: [
        221
      ],
      weight: 0.36
    },
    {
      ids: [
        12,
        33
      ],
      weight: 0.35
    },
    {
      ids: [
        34
      ],
      weight: 0.3
    },
    {
      ids: [
        8,
        9,
        201,
        216
      ],
      weight: 0.2
    },
    {
      ids: [
        204
      ],
      weight: 0.15
    }
  ],
  centerId: 16,
  center: new THREE.Vector3(0, 0, 0),
  name: "Forefoot Medial Wedge",
  min: 0,
  max: 10,
  value: 0,
  cval: 0,
  bval: 1,
};

export const HighHeelV1Config: MeshConfig = {
  joints: {
    profile: [
      P0, P1, P2, P3, P4, P5, P6, P7, P8, P9, P10, P11, P12, P13, P14, P15, P16,
      P17, P18, P19, P20, P21, P22, P23, P24, P25, P26, P27, P28, P29, P30, P31
    ],

    surface: {
      heelHeight: heelHeightJoint,
      heelDepth: heelDepthJoint,
      heelLateralWedge: heelLateralJoint,
      heelMedialWedge: heelMedialJoint,
      archCenterHeight: archCenterJoint,
      archLateralHeight: archLateralJoint,
      archMedialHeight: archMedialJoint,
      archSagitalPosition: archEditorJoint,
      thickness: thicknessJoint,
      forefootLateralWedge: forefootLateralJoint,
      forefootMedialWedge: forefootMedialJoint,
      bandHeight: null,
      outsoleThickness: null
    },
  },

  roofJoints: {
    vertices: [
      {
        ids: [
          0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19,
          20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37,
          38, 39, 40, 41, 42, 43, 44, 45, 46, 73, 74, 75, 76, 77, 78, 79, 80, 81,
          82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99,
          100, 101, 102, 103, 104, 105, 106, 111, 112, 116, 117, 118, 119, 120,
          159, 160, 186, 187, 188, 189, 190, 191, 192, 193, 194, 195, 196, 201,
          202, 203, 204, 205, 206, 207, 210, 211, 212, 213, 214, 215, 219, 220,
          221, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 235, 236, 240,
          241, 242, 251, 254,
        ],
        weight: 1.0,
      },
    ],
    centerId: 30,
    name: "RoofJoints",
    min: 0,
    max: 1,
    value: 0,
    center: new THREE.Vector3(0, 0, 0),
    cval: 0,
    bval: 1,
  },

  roofVertices: { // advanced points
    vertices: [
      {
        ids: [
          14, 17, 18, 28, 29, 32, 33, 35, 73, 74, 81, 83, 84, 85, 86, 88, 95,
          97, 98, 101, 104, 186, 187, 188, 189, 196, 203, 204, 206, 212, 213,
        ],
        weight: 1.0,
      },
      {
        ids: [16, 24, 219],
        weight: 1.0,
      },
      {
        ids: [15, 212, 241],
        weight: 1.0,
      },
      {
        ids: [34, 33, 221],
        weight: 1.0,
      },
      {
        ids: [31, 35, 220],
        weight: 1.0,
      },
      {
        ids: [30, 195, 242],
        weight: 1.0,
      },
      {
        ids: [99, 73, 76],
        weight: 1.0,
      },
      {
        ids: [100, 74, 75],
        weight: 1.0,
      },
      {
        ids: [232, 233, 240],
        weight: 1.0,
      },
      {
        ids: [2, 3, 112],
        weight: 1.0,
      },
      {
        ids: [103, 104, 111],
        weight: 1.0,
      },
      {
        ids: [190, 196, 211],
        weight: 1.0,
      },
      {
        ids: [26, 25, 210],
        weight: 1.0,
      },
      {
        ids: [27, 28, 236],
        weight: 1.0,
      },
      {
        ids: [205, 213, 235],
        weight: 1.0,
      },
      {
        ids: [19, 18, 202],
        weight: 1.0,
      },
      {
        ids: [20, 21, 106],
        weight: 1.0,
      },
    ],
    centerId: 30,
    name: "RoofVertices",
    min: 0,
    max: 1,
    value: 0,
    center: new THREE.Vector3(0, 0, 0),
    cval: 0,
    bval: 1,
  },

  pressureAlignmentDefault: [96, 87], // first value is Main joint, second value is Rotation joint
  archLineIndices: [18, 19, 85, 87, 17, 16, 24],
  inStepAreaIndices: [],
  heelFillIndices: [226, 261, 67, 70],
  archFillIndeices: [210, 138, 55, 58],

  forefootIndex: 94,
  archStartIndex: 20,
  archEditorIndex: 18,
  heelCenterIndex: 96,
  bandStartIndex: -1
}

